import Tooltip from '../../Tooltip';

function CompletionTooltip({ content }: { content?: string }) {
  const toolTipContent =
    content ||
    `Our belief is based on the number of symptoms you have that relate to the condition, as well as the strength of those relationships. Symptoms that are more strongly related result in higher belief.`;
  return <Tooltip title={toolTipContent} />;
}

export default CompletionTooltip;
